import { FC } from 'react';

export const SettingsMain: FC = () => {
  return (
    <div>SETTINGS</div>
  );
};
